module.exports = __webpack_public_path__ + "static/media/Shirshak_Tiple.bd912de4.jpg";